import { render, staticRenderFns } from "./pushLog.vue?vue&type=template&id=bbd233a8&scoped=true&"
import script from "./pushLog.vue?vue&type=script&lang=js&"
export * from "./pushLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd233a8",
  null
  
)

export default component.exports